
    import { apiClient } from '@/utils/apiclient';
    import { Currency, ClubPackage, MarketFeature, Country } from '@/models';
    import { mapState } from 'vuex';
    import BillingCycleSelection from '@/components/billing-cycle-selection/billing-cycle-selection.vue';
    import ClubPricingMatrixItem from '@/components/club/club-pricing-matrix-item.vue';
    import Utilities from '@/utils/utilities';
    import Vue from "vue";

    export default Vue.extend({
        name: "ClubPricing",
        components: {
            'club-pricing-matrix-item': ClubPricingMatrixItem,
            'billing-cycle-selection': BillingCycleSelection,
        },
        data() {
            return {
                selectedCountry: "",
                allPackages: [] as ClubPackage[],
                allMarketFeatures: [] as MarketFeature[],
                communicationsMarketFeature: null! as MarketFeature,
                memberMatchaMarketFeature: null! as MarketFeature,
                pointOfSaleMarketFeature: null! as MarketFeature,
                clinicsMarketFeature: null! as MarketFeature,
                courtBookingMarketFeature: null! as MarketFeature,
                courtBookingLumpOnlyFee:"",
                courtBookingLumpOnlyCurrency: null! as Currency,
                courtBookingFootnote:"",
                billingCycles: Utilities.billingCycles,
                selectedBillingCycle: {},
            }
        },
        watch: {
            selectedCountry: function() {
                this.refreshPrices();
            }
        },
        computed: {
            ...mapState([
                'countries'
            ])
        },
        methods: {
            selectBillingCycle(cycle) {
                this.selectedBillingCycle = cycle;
            },
            refreshPrices() {
                const selectedCountryObj = this.countries.find((item: Country) =>  item.code == this.selectedCountry);

                apiClient.packages().then((packageData: ClubPackage[]) => {

                    this.allPackages= packageData;

                    apiClient.marketFeatures(this.selectedCountry).then(marketFeatures => {                        

                        this.allMarketFeatures = marketFeatures;

                        // reset
                        this.communicationsMarketFeature = null! as MarketFeature;
                        this.memberMatchaMarketFeature = null! as MarketFeature;
                        this.courtBookingMarketFeature = null! as MarketFeature;
                        this.courtBookingLumpOnlyFee = "";
                        this.courtBookingFootnote = "";
                        this.pointOfSaleMarketFeature = null! as MarketFeature;
                        this.clinicsMarketFeature = null! as MarketFeature;

                        // for each package, for each feature, if it is the membership or matcha one (which we need), get it's price
                        packageData.forEach((packageItem: ClubPackage) => {
                            
                            packageItem.feature_set.forEach(clubPackageFeature => {
                                
                                const marketFeature = marketFeatures.find((marketfeature: MarketFeature) => marketfeature.feature == Number(clubPackageFeature.id));

                                if(marketFeature && clubPackageFeature.name == "communication")
                                {
                                    this.communicationsMarketFeature = marketFeature;
                                }
                                else if(marketFeature && clubPackageFeature.name == "matcha")
                                {
                                    this.memberMatchaMarketFeature = marketFeature;
                                }
                                else if(marketFeature && clubPackageFeature.name == "pointofsale")
                                {
                                    this.pointOfSaleMarketFeature = marketFeature;
                                }
                                else if(marketFeature && clubPackageFeature.name == "clinics")
                                {
                                    this.clinicsMarketFeature = marketFeature;
                                }
                                else if(marketFeature && clubPackageFeature.name == "courtbooking")
                                {
                                     if(selectedCountryObj != null && selectedCountryObj.connect_available) {
                                         this.courtBookingMarketFeature = marketFeature;
                                         this.courtBookingFootnote = "* A payment may be a membership fee or a court booking cost if you charge for bookings.<br />^ Processing fee discounts are possible based on the number of members and cost of membership. Please enquire with us.";
                                    }
                                    else {
                                        this.courtBookingLumpOnlyFee = marketFeature.lump_sum_price;
                                        this.courtBookingLumpOnlyCurrency = marketFeature.currency_obj;
                                        this.courtBookingFootnote = "* In-app payments are not available in your country. Therefore the membership fee collection feature cannot be enabled. Also you will not be able to charge for court bookings on the app";
                                    }
                                }
                            });
                        }); 
                    })
                })
                // .catch(error => { 
                //     console.log(`An error occurred getting packages and pricing [${error}]`);
                // });
            }
        },
        mounted() {
            this.selectedCountry = "US";
            this.selectedBillingCycle = this.billingCycles[0];
        }
    })
